/*
 * View for the status pills used by the topic tasks list
 */

define(["marionette", "./template/reviewerTasksListToggleTemplate.html"], function (
  Marionette,
  ReviewerTasksListToggleTemplate,
) {
  let ReviewerTasksListToggleView = {};

  ReviewerTasksListToggleView.reviewerTasksListToggleView = Marionette.ItemView.extend({
    template: ReviewerTasksListToggleTemplate,
    events: {
      //these are events and not triggers so that the event will propagate to Bootstrap
      "click #notStartedTasks": function () {
        this.trigger("show:not:started");
      },
      "click #inProgressTasks": function () {
        this.trigger("show:in:progress");
      },
      "click #rejectedTasks": function () {
        this.trigger("show:rejected");
      },
    },
    selectNotStarted: function () {
      //Use the bootstrap-y way of selecting the tab
      this.$el.find("a[id=notStartedTasks]").tab("show");
    },
  });

  return ReviewerTasksListToggleView;
});
